import produce, { Draft } from 'immer';
import { remove } from 'lodash';

import { ClientProtectedFragment, DeleteClientStickerMutation, S3Object, S3ObjectInput } from 'api';

interface IResponseOptions {
  client: ClientProtectedFragment;
  sticker: S3ObjectInput;
}

const deleteClientStickerResponse = ({
  client,
  sticker,
}: IResponseOptions): DeleteClientStickerMutation => {
  const { stickers } = client;
  const nextStickers = produce(stickers, (draft: Draft<S3Object[]>) => {
    remove(draft, draftSticker => draftSticker.key === sticker.key);
    return draft;
  });

  return {
    deleteClientSticker: {
      success: true,
      client: {
        ...client,
        stickers: nextStickers,
      },
      sticker,
      // @ts-ignore
      __typename: 'StickerResponse',
    },
  };
};

export { deleteClientStickerResponse };
